import { render, staticRenderFns } from "./VirtualAccountInfo.vue?vue&type=template&id=da9c8764&"
import script from "./VirtualAccountInfo.vue?vue&type=script&lang=js&"
export * from "./VirtualAccountInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports